import React, { useReducer, useEffect, useContext, useCallback, useState, useMemo } from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import request from 'services/http'
import { of, timer } from 'rxjs'
import { switchMap, take, map, tap, filter, catchError } from 'rxjs/operators'
import { Dimmer, Loader } from 'semantic-ui-react'
import Header from './Header'
import Sidebar from './Sidebar'
import { GlobalContext } from '../globalContext'
import jwt from 'jsonwebtoken'
import { toast } from 'react-toastify'
import { useSubscription } from 'utils'

import './TemplateIntranet.scss'

function reducer(state, action) {
    switch (action.type) {
        case 'setSidebarVisible':
            return { ...state, sidebarVisible: action.payload }
        default:
            return state
    }
}

function Template(props) {
    const { location } = props
    const [stateGlobal, dispatchGlobal] = useContext(GlobalContext)
    const [isFetching, setIsFetching] = useState(true)
    const [isRefreshingToken, setIsRefreshingToken] = useState(false)
    const [state, dispatch] = useReducer(reducer, { sidebarVisible: false })

    const toogleSidebar = useCallback(function (value) {
        dispatch({ type: 'setSidebarVisible', payload: value })
    }, [])

    const authRequest$ = useCallback(config => request(config).pipe(
        map(({ response }) => {
            localStorage.setItem('JWTANF', response.token)
            return jwt.decode(response.token)
        }),
        catchError(() => false)
    ), [])

    const checkAuthentication = useCallback(function checkAuthentication() {
        try {
            let token = localStorage.getItem('JWTANF'), cookie = decodeURIComponent(document.cookie).split("dpnet=")[1]
            if (!cookie){
                if(token){
                    token = jwt.decode(token);
                    if(!token.issuedFor){
                        return of (token)
                    }else{
                        const now = Date.now() / 1000
                        if (now < token.exp)
                            return of(token)
                    }
                }
                return of(false)
            }
            else if (cookie && token) {
                token = jwt.decode(token)
                if (cookie !== token.issuedFor) {
                    return authRequest$({ url: '/authenticate', method: 'POST', body: { cookie }, inheritError: true })
                } else {
                    const now = Date.now() / 1000
                    if (now > token.exp)
                        return authRequest$({ url: '/authenticate', method: 'POST', body: { cookie }, inheritError: true })
                    else
                        return of(token)
                }
            } else if (cookie && !token) {
                return authRequest$({ url: '/authenticate', method: 'POST', body: { cookie }, inheritError: true })
            }
        } catch (error) {
            return of(false)
        }
    }, [authRequest$])    

    const verifyAuth$ = useMemo(() => timer(0, 2000).pipe(
        switchMap(() => checkAuthentication()),
        tap(data => {
            if (!!data === false)
                dispatchGlobal({ type: 'isCheckingAuth', payload: false })
        }),
        filter(x => !!x !== false),
        take(1),
        tap(user => dispatchGlobal({ type: 'setUser', payload: user }))
    ), [checkAuthentication, dispatchGlobal])

    const empresas$ = useMemo(() => request({ url: '/common/empresas', method: 'GET' }).pipe(
        tap(({ response }) => {
            setIsFetching(false)
            dispatchGlobal({ type: 'setEmpresas', payload: response.empresas })
        })
    ), [dispatchGlobal])

    const refreshToken$ = useMemo(() => request({ url: '/authenticate', method: 'POST', body: { cookie: decodeURIComponent(document.cookie).split("dpnet=")[1] } }).pipe(
        tap(({ response }) => {
            toast.success('Sessão atualizada!')
            localStorage.setItem('JWTANF', response.token)
            setIsRefreshingToken(false)
            dispatchGlobal({ type: 'setUser', payload: jwt.decode(response.token) })
        })
    ), [dispatchGlobal])

    useSubscription(verifyAuth$, !!stateGlobal.user === false)
    useSubscription(empresas$, isFetching && stateGlobal.empresas === null && stateGlobal.user !== null)
    useSubscription(refreshToken$, isRefreshingToken)

    useEffect(() => {
        if(state.sidebarVisible === true)
            setTimeout(() => toogleSidebar(false), 300)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname])

    if (!stateGlobal.isCheckingAuth) {
        if (!stateGlobal.user && location.pathname !== '/sessao-expirada' && location.pathname !== '/login')
            return <Redirect to='/sessao-expirada' />  
        else if (stateGlobal.user && (location.pathname === '/sessao-expirada' || location.pathname==='/login'))
            return <Redirect to='/' />
    }

    const headerProps = { toogleSidebar, user: stateGlobal.user, sidebarVisible: state.sidebarVisible, isRefreshingToken, setIsRefreshingToken }
    // console.log(headerProps)

    return (
        <div id='template-intranet' className='d-flex flex-column flex-grow-1'>
            
            <Dimmer active={stateGlobal.isCheckingAuth} inverted className='d-print-none'>
                <Loader content='Checando autenticação' />
            </Dimmer>

            <Header {...headerProps} />

            <Sidebar {...headerProps} />

            {!stateGlobal?.isCheckingAuth && <div className="wrapper d-flex flex-grow-1 flex-column">
                {props.children}
            </div>}

        </div>
    )
}

export default withRouter(Template)
